
/* =====================================
   SWIPE GLOBAL DE FOTOGRAFIAS
   COM INDICADORES - MOBILE
===================================== */

(function () {
  'use strict';

  function init(root) {
    (root || document)
      .querySelectorAll('.grid-product__image-mask')
      .forEach(function (mask) {

        const secondary = mask.querySelector(
          '.mobile-product-swipe-image'
        );

        const card = mask.closest('.grid-product');

        const link = card
          ? card.querySelector('.grid-product__link')
          : null;

        if (!secondary || !link ||
            mask.dataset.imageSwipeInit === '1') return;

        mask.dataset.imageSwipeInit = '1';

        /* =====================================
           CRIAR AS DUAS BOLINHAS
        ===================================== */

        const dots = document.createElement('div');
        dots.className = 'mobile-product-swipe-dots';
        dots.setAttribute('aria-hidden', 'true');

        dots.innerHTML =
          '<span class="mobile-swipe-dot is-active"></span>' +
          '<span class="mobile-swipe-dot"></span>';

        mask.appendChild(dots);

        function updateDots() {
          const active = secondary.classList.contains(
            'is-active'
          );

          const indicators = dots.querySelectorAll(
            '.mobile-swipe-dot'
          );

          indicators[0].classList.toggle(
            'is-active',
            !active
          );

          indicators[1].classList.toggle(
            'is-active',
            active
          );
        }

        /* =====================================
           CONTROLO DO DESLIZAR
        ===================================== */

        let startX = null;
        let startY = null;
        let moved = false;
        let lastSwipe = 0;

        mask.addEventListener('touchstart', function (event) {

          if (window.innerWidth > 749 ||
              event.touches.length !== 1) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          moved = false;

        }, { passive: true });

        mask.addEventListener('touchend', function (event) {

          if (window.innerWidth > 749 ||
              startX === null ||
              !event.changedTouches.length) return;

          const dx =
            event.changedTouches[0].clientX - startX;

          const dy =
            event.changedTouches[0].clientY - startY;

          startX = null;
          startY = null;

          if (Math.abs(dx) < 35 ||
              Math.abs(dx) <= Math.abs(dy) * 1.3) return;

          /* ALTERAR FOTOGRAFIA */

          secondary.classList.toggle(
            'is-active',
            dx < 0
          );

          /* ATUALIZAR BOLINHAS */

          updateDots();

          moved = true;
          lastSwipe = Date.now();

        }, { passive: true });

        mask.addEventListener('touchcancel', function () {
          startX = null;
          startY = null;
        });

        /* =====================================
           EVITAR ABRIR PRODUTO AO DESLIZAR
        ===================================== */

        link.addEventListener('click', function (event) {

          if (moved && Date.now() - lastSwipe < 650) {
            event.preventDefault();
            event.stopPropagation();
            moved = false;
          }

        }, true);

      });
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(event.target);
    }
  );

})();
